<div>
  <app-modal-reservation-generic
    (submitReserve)="addCarwashReservation($event)"
    (submitEdit)="editCarwashReservation($event)"
  ></app-modal-reservation-generic>
  <app-modal-error-mobile></app-modal-error-mobile>
</div>
